import { z } from 'zod';

export enum CriteriaDirection {
    ENTER = 'ENTER',
    EXIT = 'EXIT',
}

export const CriteriaDirectionSchema = z.enum(CriteriaDirection);
